
import React, { useEffect, useRef, useState } from 'react';
import { get, post } from '../../../../../Model/Network/Config/Axios';
import { Card } from '../../../../Common/fCards';
import { FunctionalInput } from '../../../../Common/fInputs';
import { Modal } from '../../../../Common/fModal/Modal';
import { NormalTds } from '../../../../Common/fTax/SelectTds/Nomal';
import { showToast } from '../../../../Common/fToast/ToastCallback';
import Title from '../../../../Common/Title';
import Moment from 'moment';
import Empty from '../../../../Common/fCard/Empty';
import { Form } from '../../../../Common/Class/Form';
import { Tile } from '../../../../Common/fCard/Tile';
import {VendorAdvanceDetails} from '../../VendorAdvance/AdvanceDetails';
import { ReadOnly } from '../../../../Common/fCard/ButtonOutline/ReadOnly';
import { FileUpload } from '../../../../Common/fInputs/FunctionalFile';
import PhotoTile from '../../../../Common/fPhoto';
import SelectGST from '../../../../Common/fUtils/SelectGST';
import { useSelector } from 'react-redux';




const Advance = (props) => {

    let [add,setAdd] = useState(false);
    let [data,setData] = useState([]);
    let [requestItems,setRequestItems] =useState([]);
    let [open,setOpen] = useState(false);
    let [Files, setFiles] = useState([]);
    let [successModal, setSuccessModal] = useState(false)
    let REMARKS=useRef(),AMOUNT=useRef(),TDS=useRef(),FORM=useRef(),BASE=useRef(),TAX=useRef(),PAYABLE=useRef();
    let currency = props.data.currency;
    let {id} = props;
    let {status,procured,invoices} = props.data;
    let {enableTdsAutomationVendorAdvance} = useSelector(state=>state.auth.config.plugins);
    
    const [gst, setGst] = useState({
      value: 0,
      label: 0
  })

    

	  let totalAmount = 0, invoiceAmount = 0, advanceAmount = 0, isInvoiceSubmitted = false;
	  let sumOfRequestedAdvances = 0;
    procured.length > 0 && procured.forEach(val=>totalAmount += val.amount)
    invoices.length > 0 && invoices.forEach(val=> {
      if(val.status !== "CANCELLED" && val.status !== "DECLINED" && val.status !== "DRAFT"){
        isInvoiceSubmitted = true;
        invoiceAmount += val.currencyAmount;
      }
    })
    requestItems.length > 0 && requestItems.forEach(val=> {
      if(val.status !== "CANCELLED" && val.status !== "DECLINED"){
        advanceAmount += val.amount;
      }
    })

    useEffect(()=>{
       INIT(id)
    },[id])

    useEffect(()=>{
      RequestInit()
    },[])

    let RequestInit = () => {
      let filter = [];
      filter.push(`${id}@po_id`)
      get(`vendor/advances/pending`,(e,r)=>{
        if(r) {
            get(`vendor/advances/past`,(e1,r1)=>{
              if(r1) {
                 setRequestItems([...r1.transfers,...r.transfers])
              }
            },{filter,offset:0})
        }
      },{filter,offset:0})
    }

    useEffect(()=>{
        if(add) {
            FORM.current.loadForm(`VENDOR::ADVANCE::FORM`)
        }
    },[add])
    
    let INIT = (q) => {
        get(`vendor/po/requests/${q}/advances`,(e,r)=>{
            if(r) {
                setData(r.settlements)
            }
        })
    }
    
    let mapCard = (item,index) =>{
        return(
        <Card  key={`${index}`}
            headings={[item.ledgerId]}
            details={[{label: 'Amount', value: item.amount},{label: 'Date', value: Moment(item.createdAt).format(" hh:mm a DD MMM YY")}, {label: 'Remarks', value: item.remarks}, {label: 'settlementType', value: item.settlementType}]}
            onClick={()=>{}}>
          </Card>
        )
    }

    let mapItem = (item,index) =>{
      return(
        <Tile
			     onClick={()=>{
                  setOpen(item)
			    }}
		     title={item.vendor.name} 
         key={index}
			    badge={`INR ${item.amount}`}>
              <p className="tiny-text">
					        Id: {item.advanceId}
			  	    </p>
				      <p className="tiny-text">
					    {item.po?
					<>
						PO Number: {item.po.poNo}
					</>
					:''}
				</p>
        {item.tds && 
         <p className="tiny-text">
					Tds: {item.tds && item.tds.tds}%/{item.tds.code}
				</p>
        }
			</Tile>
      )
    }

    return (
      <>
        <div style={{ margin: "0px 40px" }}>
          <Title title="All Advance">
            <div style={{ position: "absolute", right: 0, top: -10 }}>
              {status === "GRN" || status === "INVOICE" ? (
                <ReadOnly>
                  <button
                    style={{
                      border: "var(--primary-color)",
                      background: "var(--primary-color)",
                      padding: "8px 20px",
                      color: "var(--white-color)",
                      borderRadius: 4,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setAdd(true);
                    }}
                  >
                    Add Advance
                  </button>
                </ReadOnly>
              ) : null}
            </div>
          </Title>
        </div>

        <div>
          {data.length ? (
            <div style={{ display: "flex", flexWrap: "wrap", marginLeft: 20 }}>
              {data.map(mapCard)}
            </div>
          ) : (
            <Empty style={{ marginLeft: "20px" }} />
          )}
        </div>

        <div style={{margin:'0px 40px'}}>
          <Title title="Advance Request" />
          {requestItems.length ? (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {requestItems.map(mapItem)}
            </div>
          ) : (
            <Empty style={{ marginLeft: "20px" }} />
          )}
        </div>

        <Modal
          title="Add Advance"
          des="Fill up the details"
          close={() => {
            setAdd(false);
          }}
          show={add}
          onSave={() => {
            let remarks = REMARKS.current.value;
            let tds = undefined;
            let base = +BASE.current.value;
            let amount = AMOUNT && AMOUNT.current && +AMOUNT.current.value;
            let tax =  TAX.current && +TAX.current.value;

            if (currency === "INR" && !enableTdsAutomationVendorAdvance) {
              tds = TDS.current.getValue();
            }
            if(!base) {
              showToast({
                  type:'error',
                  message:"Please enter the base amount"
              })
              return;
          }
            if (!remarks) {
              showToast({
                type: "error",
                message: "Please enter the remarks",
              });
              return;
            }
            if (!enableTdsAutomationVendorAdvance && !tds && currency === "INR") {
              showToast({
                type: "error",
                message: "Please select the tds",
              });
              return;
            }

            if(amount > (totalAmount - (invoiceAmount + advanceAmount))){
              showToast({
                type: "error",
                message: isInvoiceSubmitted ? "Requested amount exceeds the remaining PO balance after invoice adjustments." : "Advance amount cannot exceed the PO amount.",
              });
              return;
            }

            Files=Files.map((file)=>({title:file,path:file}))
            let data = {
              amount,
              remarks,
              ...(tds)?{tds:tds.id}:{},
              currency,
              tax,
              base,
              attachmentRequest:{attachments:Files},
              taxSlab: Number(gst.value)
            };
            if(!Number(gst.value) && Number(tax)){
              delete data.taxSlab;
            }
            if ((amount && totalAmount) && amount > totalAmount) {
              showToast({
                type: "error",
                message: "Amount should not greater then PO Amount",
              });
            }  else  if((sumOfRequestedAdvances && totalAmount) && sumOfRequestedAdvances > totalAmount) {
              showToast({
                type: "error",
                message: "Sum of Advance Request should not greater then PO Amount",
              });
            } else {
              FORM.current.getKeyValue((forms) => {
                data.forms = forms;
                post(
                  `vendor/po/requests/${id}/advanceV2`,
                  { ...data },
                  (e, r) => {
                    if (r) {
                      setAdd(false);
                      // INIT(id);
                      // RequestInit()
                      // props.init();
                      // showToast({
                      //   type: "success",
                      //   message: "advance add successfully",
                      // });
                      setSuccessModal(r)
                    }
                  }
                );
              });
            }
          }}
        >
          <FunctionalInput type="text" title="Base Amount" ref={BASE}
            onChange={(e) => {
              let val = e.target.value
              const baseAmount = Number(val);
              const gstValue = gst.value;
              let tax = (baseAmount / 100) * Number(gstValue)
              // taking tax amount
              if(!Number(gstValue)){
                tax = Number(TAX.current.value || 0)
              }
              TAX.current.value = (tax).toFixed(2)
              AMOUNT.current.value = (tax + baseAmount).toFixed(2)
              // TDS minus the base amount to get payable amount 
              let tds = (currency === "INR" && !enableTdsAutomationVendorAdvance && TDS.current.getValue()) ? TDS.current.getValue().tax : 0;
              const tdsTax = (Number(baseAmount) * Number(tds) / 100)
              PAYABLE.current.value = (Number(baseAmount) + tax - tdsTax).toFixed(2)

            }}
          />
          <SelectGST defaultValue={gst} placeholder="Select Gst" onSelect={(val) => {
            const baseValue = Number(BASE.current.value);
            const gstPercentage = Number(val.value);
            setGst({
              value: gstPercentage,
              label: val.label
            })
            const tax = (Number(baseValue) * gstPercentage / 100)
            TAX.current.value = (tax).toFixed(2)
            AMOUNT.current.value = (tax + baseValue).toFixed(2)
            // For Tds
            let tds = (currency === "INR" && !enableTdsAutomationVendorAdvance && TDS.current.getValue()) ? TDS.current.getValue().tax : 0;
            const tdsTax = (Number(baseValue) * Number(tds) / 100)
            PAYABLE.current.value = (baseValue + tax - tdsTax).toFixed(2)
          }}/>

          <FunctionalInput type="text" title="GST Amount" ref={TAX}
            onChange={(e) => {
              let tax = Number(e.target.value)
              setGst({
                value: 0,
                label: 0
              })
              const baseValue = Number(BASE.current.value);
              AMOUNT.current.value = (tax + baseValue).toFixed(2)
              let tds = (currency === "INR" && !enableTdsAutomationVendorAdvance && TDS.current.getValue()) ? TDS.current.getValue().tax : 0;
              const tdsTax = (Number(baseValue) * Number(tds) / 100)
              PAYABLE.current.value = (baseValue + tax - tdsTax).toFixed(2)
            }}
          />

          {(currency === "INR" && !enableTdsAutomationVendorAdvance) ? (
            <NormalTds handleRef={(ref) => (TDS.current = ref)} 
            onSelect={(tds) => {
              const baseValue = Number(BASE.current.value);
              const tdsPercentage = tds && tds.tax && tds.tax
              const tdsTax = (Number(baseValue) * Number(tdsPercentage||0) / 100);
              const gstTax= Number(TAX.current.value || 0);
              PAYABLE.current.value = (baseValue+gstTax-tdsTax).toFixed(2)
          }}
            />
          ) : (
            <></>
          )}
          <FunctionalInput type="text" title="Total Amount" ref={AMOUNT} disabled />
          <FunctionalInput type="text" title="Total Payable(after tds deduction)" ref={PAYABLE} disabled />
          <FunctionalInput type="text" title="Remarks" ref={REMARKS} />
          <div style={{marginTop:'15px'}} className='input-label'>Attachments</div>
          <div style={{
                        display:'flex',
                        flexWrap: 'wrap',
                        maxHeight: '250px',
                        overflowY: 'scroll'
                    }}>
              <FileUpload onUpload={({file}) => {
                  setFiles(prev => [...prev, file]);
              }}/>
              {
                  Files.length > 0 ?
                      Files.map((item, index) => {
                      return (
                          <PhotoTile onDelete={()=>{
                              let all = [...Files];
                              all = all.filter(i=>i!==item);
                              setFiles(all)
                          }} key={`Photo-${index}`} link={item}/>
                      )
                  }) : <></>
              }
          </div>
          <Form handler={(ref) => (FORM.current = ref)} />
        </Modal>
        {
                open ?
                <VendorAdvanceDetails onClose={()=>{setOpen(false)}} data={open}/>:
                null
            }
        {successModal && 
          <Modal 
            show={successModal} 
            title='Advance Added successfully' 
            des={`Advance Id : ${successModal.advanceId}`} 
            buttonName={'Done'} 
            onSave={()=>{
              setSuccessModal(false)
              INIT(id);
              RequestInit()
              props.init();
            }} 
            close={()=>{
              setSuccessModal(false)
              INIT(id);
              RequestInit()
              props.init();
            }}
          />
        }
      </>
    );
}

export default Advance;